import type { AxiosResponse } from "axios"
import qs from "qs"

import { ENV } from "@be-miniapp/app-configs"

import { httpPost } from "../http"
import type { Invoice } from "./autos"

export interface UserSavedAddress {
  id: number
  address: string
  google_place_id: string
  type: string
  latitude: number
  longitude: number
  is_confirmed: number
  instructions?: any
  lat?: string
  lng?: string
}

export interface Userdata {
  user_name: string
  user_email: string
  user_image: string
  locale: string
  phone_no: string
  country_code: number
  operator_id: number
  wallet_balance: Walletbalance
  email_verification_status: number
  auth_key: string
  referral_code: string
  user_id: number
  user_identifier: string
  meals_enabled: number
  fresh_enabled: number
  grocery_enabled: number
  menus_enabled: number
  pay_enabled: number
  feed_enabled: number
  pros_enabled: number
  autos_enabled: number
  delivery_customer_enabled: number
  emergency_contacts: any[]
  default_client_id: string
  promotions: any[]
  coupons: any[]
  jeanie_intro_dialog_content: Jeanieintrodialogcontent
  sharing_og_title: string
  promo_success: number
  user_debt: number
  show_subscription_data: number
  slide_checkout_pay_enabled: number
  show_jeanie_help_text: string
  expand_jeanie: number
  expanded_genie_text: string
  show_jstar_in_account: string
  show_home: number
  debt_money: number
  dob: string
  subscription_data: Subscriptiondata
  show_tutorial: number
  signup_onboarding: number
  showUserRating: boolean
  invoices: Invoice[]
  delivery_term_and_conditions: number
  public_access_token: string
  current_user_status: number
  popup?: any
  num_coupons_available: number
  user_saved_addresses: UserSavedAddress[]
  user_home_address: string
  pointsOfInterest: any[]
  customer_support_number: string
  customer_support_email: string
  city?: any
  city_id?: any
  betix_enable: boolean
  pin_info: Pininfo
  pin_exist: boolean
  access_token: string
  rating: number
  rate_app: number
  rate_app_dialog_content: Rateappdialogcontent
  is_login_otp: boolean
}

interface Rateappdialogcontent {
  title: string
  text: string
  confirm_button_text: string
  cancel_button_text: string
  url: string
  never_button_text: string
}

interface Pininfo {
  pin_token: string
}

interface Subscriptiondata {
  user_subscriptions: any[]
  subscriptions: any[]
  sub_text_autos: string
  subscription_title: string
  subscription_title_new: string
  subscribed_user: number
  subscription_screen_title: boolean
  subscription_screen_subtitle: string
  subscription_benefits: Subscriptionbenefit[]
  sub_text_fresh: string
}

interface Subscriptionbenefit {
  title: string
  description: string
  product_type: number
  priority: number
}

interface Jeanieintrodialogcontent {
  autos_text: string
  meals_text: string
  fresh_text: string
  menus_text: string
}

interface Walletbalance {
  viaLogin: number
  payment_mode_config_data: (Paymentmodeconfigdatum | null)[]
  operator_token: string
  paygate_ewallets: any[]
  jugnoo_balance: number
}

interface Paymentmodeconfigdatum {
  name: string
  enabled: number | string
  balance?: number
  display_name?: string
  payment_mode?: number
  paygate_cards?: any[]
}

export async function V4CustomerLoginUsingAccessToken(options?: {
  formUrlEncoded?: boolean
}): Promise<AxiosResponse<any>> {
  const headers = options?.formUrlEncoded
    ? { "Content-Type": "application/x-www-form-urlencoded" }
    : { "Content-Type": "application/json" }

  const data = options?.formUrlEncoded ? qs.stringify({}) : {}

  return httpPost(
    !options?.formUrlEncoded
      ? "be-autos/customer/get_user_info"
      : "be-autos/v4/customer/login_using_access_token",
    data,
    { headers }
  )
}

export interface V4CustomerGenerateLoginOTPParams {
  phoneNo: string
}

export interface V4CustomerGenerateLoginOTPResponse {
  flag: number
  message: string
  error?: string
  otp_length: number
  knowlarity_missed_call_number: string
  otp_via_call_enabled: number
  config: {
    limitSms: number
    limitSendOTPFirebaseInternal: number
    limitVoice: number
    countDownSms: number[]
    countDownVoice: number[]
    limitVerifyOTP: number
  }
  totalSentOTP: number
  should_create_pin: boolean
  pin_available: boolean
  must_verify_otp_via_firebase: boolean
}

export async function V4CustomerGenerateLoginOTP(
  params: V4CustomerGenerateLoginOTPParams
): Promise<AxiosResponse<V4CustomerGenerateLoginOTPResponse>> {
  const data = qs.stringify({
    phone_no: params.phoneNo,
    country_code: "+84",
    use_pin: "1",
    env: ENV,
    term_and_condition:
      "By continuing, You agree with be’s Regulations, Transportation Service Contract and allow be to process your Personal Data.",
  })

  return httpPost("be-autos/v4/customer/generate_login_otp", data, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  })
}

export interface V5CustomerVerifyOTPParams {
  phone_no: string
  country: string
  login_type: string
  reg_wallet_type: string
  advertising_id: string
  country_code: string
  login_otp: string
  term_and_condition: string
}

export interface V5CustomerVerifyOTPResponse {
  flag: number
  message: string
  error?: string
  user_data: any
  customer_pickup_distance: number
  is_first_transport_ride: boolean
  is_login_otp: boolean
  autos: any
  pin_info: {
    code: number
    num_attempts: number
    pin_token: string
    max_num_attempts: number
  }
}

export async function V5CustomerVerifyOTP(
  params: V5CustomerVerifyOTPParams
): Promise<AxiosResponse<V5CustomerVerifyOTPResponse>> {
  const data = qs.stringify(params)
  return httpPost("be-autos/v5/customer/verify_otp", data, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  })
}

export interface V5CustomerVerifyPinBody {
  phone_no: string
  country: string
  screen_type: string
  login_type: string
  hide_top_bar: boolean
  country_code: string
  bottom_bar_height: number
  pin: string
  term_and_condition: string
}

export async function V5CustomerVerifyPin(
  body: V5CustomerVerifyPinBody
): Promise<AxiosResponse<V5CustomerVerifyOTPResponse>> {
  return httpPost("be-autos/v5/customer/verify_otp", body)
}
